import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['apex-table']

  selectDay ({ target }) {
    return Promise.all(this.apexTableOutlets.map(table => table.refresh({ event_day_id: target.value })))
  }

  selectPeriod ({ target }) {
    return Promise.all(this.apexTableOutlets.map(table => table.refresh({ realtime_period: target.value })))
  }

  toggleOutCounts ({ target }) {
    this.apexTableOutlets.forEach(table => table.toggleOutCounts(target.checked))
  }
}
